import fetch from "auth/FetchInterceptor";
import { getResponse } from "helpers/getResponse";
// import axios from 'axios'
const JwtAuthService = {};

JwtAuthService.login = async function (data) {
  return new Promise((resolve, reject) => {
    fetch({
      url: "/admin/login",
      method: "post",
      headers: {
        "public-request": "true",
      },
      data: data,
    })
      .then((user) => resolve(user))
      .catch((err) => reject(err));
  });
};

JwtAuthService.signUp = function (data) {
  return fetch({
    url: "/auth/signup",
    method: "post",
    headers: {
      "public-request": "true",
    },
    data: data,
  });
};

JwtAuthService.changePass = function (data) {
  return fetch
    .put(`/admin/change-password`, data)
    .then((res) => getResponse(res))
    .catch((err) => getResponse(err));
};

export default JwtAuthService;
